export const Services = {
  "TICKETS": {
    "path": "https://servicedeskapitickets.azurewebsites.net/",
    "descrp": "API TO HANDLE REPORT"
  },
  "REPORT_SERVICE": {
    "path": "https://servicereportapi.azurewebsites.net",
    "descrp": "API TO HANDLE REPORT"
  }
}
